// tslint:disable
/// <reference path="../custom.d.ts" />
/**
 * Reposit API
 * The Reposit API
 *
 * The version of the OpenAPI document: 2.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import globalAxios, { AxiosPromise, AxiosInstance } from 'axios';
import { Configuration } from '../configuration';
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../base';

import { CreateOrganizationBankAccountDTO } from '../models';
import { OrganizationBankAccountDTO } from '../models';
import { UpdateOrganizationBankAccountVerificationNameDTO } from '../models';
/**
 * OrganizationBankAccountsApi - axios parameter creator
 * @export
 */
export const OrganizationBankAccountsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Add a bank account to an organization
         * @param {string} organizationId Organization id
         * @param {CreateOrganizationBankAccountDTO} createOrganizationBankAccountDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        create(organizationId: string, createOrganizationBankAccountDTO: CreateOrganizationBankAccountDTO, options: any = {}): RequestArgs {
            // verify required parameter 'organizationId' is not null or undefined
            if (organizationId === null || organizationId === undefined) {
                throw new RequiredError('organizationId','Required parameter organizationId was null or undefined when calling create.');
            }
            // verify required parameter 'createOrganizationBankAccountDTO' is not null or undefined
            if (createOrganizationBankAccountDTO === null || createOrganizationBankAccountDTO === undefined) {
                throw new RequiredError('createOrganizationBankAccountDTO','Required parameter createOrganizationBankAccountDTO was null or undefined when calling create.');
            }
            const localVarPath = `/v2/organizations/{organizationId}/bank-accounts`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            const localVarUrlObj = new URL(localVarPath, 'http://placeholder');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            Object.entries({...localVarQueryParameter, ...options.query}).forEach(([key, value]) => {
                if (value !== undefined) {
                    localVarUrlObj.searchParams.set(key, String(value));
                }
            });
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};
            const needsSerialization = (<any>"CreateOrganizationBankAccountDTO" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(createOrganizationBankAccountDTO !== undefined ? createOrganizationBankAccountDTO : {}) : (createOrganizationBankAccountDTO || "");

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search,
                options: localVarRequestOptions,
            };
        },
        /**
         * Delete a Bank Account from an Organization
         * @param {string} organizationId Organization id
         * @param {string} id Organization Bank Account id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteBankAccount(organizationId: string, id: string, options: any = {}): RequestArgs {
            // verify required parameter 'organizationId' is not null or undefined
            if (organizationId === null || organizationId === undefined) {
                throw new RequiredError('organizationId','Required parameter organizationId was null or undefined when calling deleteBankAccount.');
            }
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling deleteBankAccount.');
            }
            const localVarPath = `/v2/organizations/{organizationId}/bank-accounts/{id}`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = new URL(localVarPath, 'http://placeholder');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            Object.entries({...localVarQueryParameter, ...options.query}).forEach(([key, value]) => {
                if (value !== undefined) {
                    localVarUrlObj.searchParams.set(key, String(value));
                }
            });
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search,
                options: localVarRequestOptions,
            };
        },
        /**
         * Get all Bank Accounts for an Organization
         * @param {string} organizationId Organization id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBankAccounts(organizationId: string, options: any = {}): RequestArgs {
            // verify required parameter 'organizationId' is not null or undefined
            if (organizationId === null || organizationId === undefined) {
                throw new RequiredError('organizationId','Required parameter organizationId was null or undefined when calling getBankAccounts.');
            }
            const localVarPath = `/v2/organizations/{organizationId}/bank-accounts`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            const localVarUrlObj = new URL(localVarPath, 'http://placeholder');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            Object.entries({...localVarQueryParameter, ...options.query}).forEach(([key, value]) => {
                if (value !== undefined) {
                    localVarUrlObj.searchParams.set(key, String(value));
                }
            });
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search,
                options: localVarRequestOptions,
            };
        },
        /**
         * Update the verification name on an organization bank account
         * @param {string} organizationId Organization id
         * @param {string} id Organization Bank Account id
         * @param {UpdateOrganizationBankAccountVerificationNameDTO} updateOrganizationBankAccountVerificationNameDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateVerificationName(organizationId: string, id: string, updateOrganizationBankAccountVerificationNameDTO: UpdateOrganizationBankAccountVerificationNameDTO, options: any = {}): RequestArgs {
            // verify required parameter 'organizationId' is not null or undefined
            if (organizationId === null || organizationId === undefined) {
                throw new RequiredError('organizationId','Required parameter organizationId was null or undefined when calling updateVerificationName.');
            }
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling updateVerificationName.');
            }
            // verify required parameter 'updateOrganizationBankAccountVerificationNameDTO' is not null or undefined
            if (updateOrganizationBankAccountVerificationNameDTO === null || updateOrganizationBankAccountVerificationNameDTO === undefined) {
                throw new RequiredError('updateOrganizationBankAccountVerificationNameDTO','Required parameter updateOrganizationBankAccountVerificationNameDTO was null or undefined when calling updateVerificationName.');
            }
            const localVarPath = `/v2/organizations/{organizationId}/bank-accounts/{id}/verification-name`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = new URL(localVarPath, 'http://placeholder');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            Object.entries({...localVarQueryParameter, ...options.query}).forEach(([key, value]) => {
                if (value !== undefined) {
                    localVarUrlObj.searchParams.set(key, String(value));
                }
            });
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};
            const needsSerialization = (<any>"UpdateOrganizationBankAccountVerificationNameDTO" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(updateOrganizationBankAccountVerificationNameDTO !== undefined ? updateOrganizationBankAccountVerificationNameDTO : {}) : (updateOrganizationBankAccountVerificationNameDTO || "");

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search,
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * OrganizationBankAccountsApi - functional programming interface
 * @export
 */
export const OrganizationBankAccountsApiFp = function(configuration?: Configuration) {
    return {
        /**
         * Add a bank account to an organization
         * @param {string} organizationId Organization id
         * @param {CreateOrganizationBankAccountDTO} createOrganizationBankAccountDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        create(organizationId: string, createOrganizationBankAccountDTO: CreateOrganizationBankAccountDTO, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<OrganizationBankAccountDTO> {
            const localVarAxiosArgs = OrganizationBankAccountsApiAxiosParamCreator(configuration).create(organizationId, createOrganizationBankAccountDTO, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Delete a Bank Account from an Organization
         * @param {string} organizationId Organization id
         * @param {string} id Organization Bank Account id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteBankAccount(organizationId: string, id: string, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<object> {
            const localVarAxiosArgs = OrganizationBankAccountsApiAxiosParamCreator(configuration).deleteBankAccount(organizationId, id, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Get all Bank Accounts for an Organization
         * @param {string} organizationId Organization id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBankAccounts(organizationId: string, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<OrganizationBankAccountDTO>> {
            const localVarAxiosArgs = OrganizationBankAccountsApiAxiosParamCreator(configuration).getBankAccounts(organizationId, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Update the verification name on an organization bank account
         * @param {string} organizationId Organization id
         * @param {string} id Organization Bank Account id
         * @param {UpdateOrganizationBankAccountVerificationNameDTO} updateOrganizationBankAccountVerificationNameDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateVerificationName(organizationId: string, id: string, updateOrganizationBankAccountVerificationNameDTO: UpdateOrganizationBankAccountVerificationNameDTO, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<OrganizationBankAccountDTO> {
            const localVarAxiosArgs = OrganizationBankAccountsApiAxiosParamCreator(configuration).updateVerificationName(organizationId, id, updateOrganizationBankAccountVerificationNameDTO, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * OrganizationBankAccountsApi - factory interface
 * @export
 */
export const OrganizationBankAccountsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         * Add a bank account to an organization
         * @param {string} organizationId Organization id
         * @param {CreateOrganizationBankAccountDTO} createOrganizationBankAccountDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        create(organizationId: string, createOrganizationBankAccountDTO: CreateOrganizationBankAccountDTO, options?: any) {
            return OrganizationBankAccountsApiFp(configuration).create(organizationId, createOrganizationBankAccountDTO, options)(axios, basePath);
        },
        /**
         * Delete a Bank Account from an Organization
         * @param {string} organizationId Organization id
         * @param {string} id Organization Bank Account id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteBankAccount(organizationId: string, id: string, options?: any) {
            return OrganizationBankAccountsApiFp(configuration).deleteBankAccount(organizationId, id, options)(axios, basePath);
        },
        /**
         * Get all Bank Accounts for an Organization
         * @param {string} organizationId Organization id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBankAccounts(organizationId: string, options?: any) {
            return OrganizationBankAccountsApiFp(configuration).getBankAccounts(organizationId, options)(axios, basePath);
        },
        /**
         * Update the verification name on an organization bank account
         * @param {string} organizationId Organization id
         * @param {string} id Organization Bank Account id
         * @param {UpdateOrganizationBankAccountVerificationNameDTO} updateOrganizationBankAccountVerificationNameDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateVerificationName(organizationId: string, id: string, updateOrganizationBankAccountVerificationNameDTO: UpdateOrganizationBankAccountVerificationNameDTO, options?: any) {
            return OrganizationBankAccountsApiFp(configuration).updateVerificationName(organizationId, id, updateOrganizationBankAccountVerificationNameDTO, options)(axios, basePath);
        },
    };
};

/**
 * OrganizationBankAccountsApi - interface
 * @export
 * @interface OrganizationBankAccountsApi
 */
export interface OrganizationBankAccountsApiInterface {
    /**
     * Add a bank account to an organization
     * @param {string} organizationId Organization id
     * @param {CreateOrganizationBankAccountDTO} createOrganizationBankAccountDTO 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganizationBankAccountsApiInterface
     */
    create(organizationId: string, createOrganizationBankAccountDTO: CreateOrganizationBankAccountDTO, options?: any): AxiosPromise<OrganizationBankAccountDTO>;

    /**
     * Delete a Bank Account from an Organization
     * @param {string} organizationId Organization id
     * @param {string} id Organization Bank Account id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganizationBankAccountsApiInterface
     */
    deleteBankAccount(organizationId: string, id: string, options?: any): AxiosPromise<object>;

    /**
     * Get all Bank Accounts for an Organization
     * @param {string} organizationId Organization id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganizationBankAccountsApiInterface
     */
    getBankAccounts(organizationId: string, options?: any): AxiosPromise<Array<OrganizationBankAccountDTO>>;

    /**
     * Update the verification name on an organization bank account
     * @param {string} organizationId Organization id
     * @param {string} id Organization Bank Account id
     * @param {UpdateOrganizationBankAccountVerificationNameDTO} updateOrganizationBankAccountVerificationNameDTO 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganizationBankAccountsApiInterface
     */
    updateVerificationName(organizationId: string, id: string, updateOrganizationBankAccountVerificationNameDTO: UpdateOrganizationBankAccountVerificationNameDTO, options?: any): AxiosPromise<OrganizationBankAccountDTO>;

}

/**
 * OrganizationBankAccountsApi - object-oriented interface
 * @export
 * @class OrganizationBankAccountsApi
 * @extends {BaseAPI}
 */
export class OrganizationBankAccountsApi extends BaseAPI implements OrganizationBankAccountsApiInterface {
    /**
     * Add a bank account to an organization
     * @param {string} organizationId Organization id
     * @param {CreateOrganizationBankAccountDTO} createOrganizationBankAccountDTO 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganizationBankAccountsApi
     */
    public create(organizationId: string, createOrganizationBankAccountDTO: CreateOrganizationBankAccountDTO, options?: any) {
        return OrganizationBankAccountsApiFp(this.configuration).create(organizationId, createOrganizationBankAccountDTO, options)(this.axios, this.basePath);
    }

    /**
     * Delete a Bank Account from an Organization
     * @param {string} organizationId Organization id
     * @param {string} id Organization Bank Account id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganizationBankAccountsApi
     */
    public deleteBankAccount(organizationId: string, id: string, options?: any) {
        return OrganizationBankAccountsApiFp(this.configuration).deleteBankAccount(organizationId, id, options)(this.axios, this.basePath);
    }

    /**
     * Get all Bank Accounts for an Organization
     * @param {string} organizationId Organization id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganizationBankAccountsApi
     */
    public getBankAccounts(organizationId: string, options?: any) {
        return OrganizationBankAccountsApiFp(this.configuration).getBankAccounts(organizationId, options)(this.axios, this.basePath);
    }

    /**
     * Update the verification name on an organization bank account
     * @param {string} organizationId Organization id
     * @param {string} id Organization Bank Account id
     * @param {UpdateOrganizationBankAccountVerificationNameDTO} updateOrganizationBankAccountVerificationNameDTO 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganizationBankAccountsApi
     */
    public updateVerificationName(organizationId: string, id: string, updateOrganizationBankAccountVerificationNameDTO: UpdateOrganizationBankAccountVerificationNameDTO, options?: any) {
        return OrganizationBankAccountsApiFp(this.configuration).updateVerificationName(organizationId, id, updateOrganizationBankAccountVerificationNameDTO, options)(this.axios, this.basePath);
    }

}

/**
 * Standalone tree-shakeable functions for OrganizationBankAccountsApi
 * Import individual functions for optimal bundle size
 */
/**
 * Add a bank account to an organization
 * @param {string} organizationId Organization id
 * @param {CreateOrganizationBankAccountDTO} createOrganizationBankAccountDTO 
 * @param {Configuration} [configuration] Optional configuration
 * @param {AxiosInstance} [axios] Optional axios instance
 * @param {string} [basePath] Optional base path
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
export async function create(
    organizationId: string,
    createOrganizationBankAccountDTO: CreateOrganizationBankAccountDTO,
    configuration?: Configuration,
    axios: AxiosInstance = globalAxios,
    basePath: string = BASE_PATH,
    options?: any
): Promise<OrganizationBankAccountDTO> {
    const localVarAxiosArgs = OrganizationBankAccountsApiAxiosParamCreator(configuration).create(organizationId, createOrganizationBankAccountDTO, options);
    const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
    const __response = await axios.request(axiosRequestArgs);
    return __response.data;
}

/**
 * Delete a Bank Account from an Organization
 * @param {string} organizationId Organization id
 * @param {string} id Organization Bank Account id
 * @param {Configuration} [configuration] Optional configuration
 * @param {AxiosInstance} [axios] Optional axios instance
 * @param {string} [basePath] Optional base path
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
export async function deleteBankAccount(
    organizationId: string,
    id: string,
    configuration?: Configuration,
    axios: AxiosInstance = globalAxios,
    basePath: string = BASE_PATH,
    options?: any
): Promise<object> {
    const localVarAxiosArgs = OrganizationBankAccountsApiAxiosParamCreator(configuration).deleteBankAccount(organizationId, id, options);
    const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
    const __response = await axios.request(axiosRequestArgs);
    return __response.data;
}

/**
 * Get all Bank Accounts for an Organization
 * @param {string} organizationId Organization id 
 * @param {Configuration} [configuration] Optional configuration
 * @param {AxiosInstance} [axios] Optional axios instance
 * @param {string} [basePath] Optional base path
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
export async function getBankAccounts(
    organizationId: string,
    configuration?: Configuration,
    axios: AxiosInstance = globalAxios,
    basePath: string = BASE_PATH,
    options?: any
): Promise<Array<OrganizationBankAccountDTO>> {
    const localVarAxiosArgs = OrganizationBankAccountsApiAxiosParamCreator(configuration).getBankAccounts(organizationId, options);
    const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
    const __response = await axios.request(axiosRequestArgs);
    return __response.data;
}

/**
 * Update the verification name on an organization bank account
 * @param {string} organizationId Organization id
 * @param {string} id Organization Bank Account id
 * @param {UpdateOrganizationBankAccountVerificationNameDTO} updateOrganizationBankAccountVerificationNameDTO 
 * @param {Configuration} [configuration] Optional configuration
 * @param {AxiosInstance} [axios] Optional axios instance
 * @param {string} [basePath] Optional base path
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
export async function updateVerificationName(
    organizationId: string,
    id: string,
    updateOrganizationBankAccountVerificationNameDTO: UpdateOrganizationBankAccountVerificationNameDTO,
    configuration?: Configuration,
    axios: AxiosInstance = globalAxios,
    basePath: string = BASE_PATH,
    options?: any
): Promise<OrganizationBankAccountDTO> {
    const localVarAxiosArgs = OrganizationBankAccountsApiAxiosParamCreator(configuration).updateVerificationName(organizationId, id, updateOrganizationBankAccountVerificationNameDTO, options);
    const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
    const __response = await axios.request(axiosRequestArgs);
    return __response.data;
}

